import apiCallTemplate from "./config";
import credentials from "../assets/credentials";

const { BASE_URL } = credentials;
const orderURL = `${BASE_URL}/orders`;

//cancel order
export const cancelOrder = async (orderId) =>
  apiCallTemplate("get", `${orderURL}/cancel/${orderId}`);

//cancel order -guest user
export const cancelOrderNonRegUser = async (orderId, email) =>
  apiCallTemplate("get", `${orderURL}/cancel/non-user/${orderId}/${email}`);

//report order
export const reportOrderAsFake = async (orderId) =>
  apiCallTemplate("get", `${orderURL}/fake/${orderId}`);

//report order -guest user
export const reportOrderAsFakenonRegUser = async (orderId, email) =>
  apiCallTemplate("get", `${orderURL}/fake/non-user/${orderId}/${email}`);

//Get all orders -admin [include limit and page in the query params]
export const allOrders = async (inputQuery) =>
  apiCallTemplate("get", `${orderURL}?${inputQuery}`);

//get order stats
export const ordersStats = async () =>
  apiCallTemplate("get", `${orderURL}/order-stats`);

//Get order by id
export const getOrderById = async (id) =>
  apiCallTemplate("get", `${orderURL}/${id}`);

//Submit credentials
export const submitCredentials = async (orderId, data) =>
  apiCallTemplate("put", `${orderURL}/${orderId}/submit-credentials`, data);

//Fetch credentials
export const getOrderCredentials = async (data) =>
  apiCallTemplate("post", `${orderURL}/reveal/credentials`, data);

//get last 30days orders
export const getRecentOrders = async () =>
  apiCallTemplate("get", `${orderURL}/recent`);

//get user sales
export const getUserSales = async (userId, query) =>
  apiCallTemplate("get", `${orderURL}/user/sales/${userId || ""}${query}`);

//get user orders
export const getUserOrders = async (userId, query) =>
  apiCallTemplate("get", `${orderURL}/user/orders/${userId || "me"}${query}`);

//get user sales stats
export const getUserSalesStats = async (userId) =>
  apiCallTemplate("get", `${orderURL}/user/sales-stats/${userId}`);

//get user orders stats
export const getUserOrderStats = async (userId) =>
  apiCallTemplate("get", `${orderURL}/user/orders-stats/${userId}`);

//get user orders stats in number
export const getUserOderStats = async (userId) =>
  apiCallTemplate("get", `${orderURL}/user/stats/${userId}`);

//get bar info
export const getSiteOderBarStats = async () =>
  apiCallTemplate("get", `${orderURL}/stats/order-bar-info`);

//get bar info
export const getUserOderBarStats = async () =>
  apiCallTemplate("get", `${orderURL}/stats/order-bar-info`);
export const getUserSalesVsBuyStats = async () =>
  apiCallTemplate("get", `${orderURL}/stats/get/order-vs-sales`);
